import FileLoader from './FileLoader';

export default FileLoader;